import api from './api';

// Tipos de datos para UF Types
export interface UFType {
  id: number;
  name: string;
  icon: string;
  usages: number;
}

interface UFTypeResponse {
  success: boolean;
  message: string;
  data: UFType | UFType[];
}

interface CreateUFTypeDTO {
  name: string;
  icon: string;
}

interface UpdateUFTypeDTO {
  name: string;
  icon: string;
}

// Servicios para UF Types

/**
 * Obtiene todos los tipos de unidades funcionales
 */
export const getAllUFTypes = async (): Promise<UFType[]> => {
  const response = await api.get<UFTypeResponse>('/uf-types');
  return Array.isArray(response.data.data) ? response.data.data : [];
};

/**
 * Crea un nuevo tipo de unidad funcional
 */
export const createUFType = async (data: CreateUFTypeDTO): Promise<UFType> => {
  const response = await api.post<UFTypeResponse>('/uf-types', data);
  return response.data.data as UFType;
};

/**
 * Actualiza un tipo de unidad funcional existente
 */
export const updateUFType = async (
  id: number,
  data: UpdateUFTypeDTO,
): Promise<void> => {
  await api.put(`/uf-types/${id}`, data);
};

/**
 * Elimina un tipo de unidad funcional
 */
export const deleteUFType = async (id: number): Promise<void> => {
  await api.delete(`/uf-types/${id}`);
};
